import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ivclass from '../../../../Modules/IVClass';
import HeaderConfig from '../../../../constants/header';
import { logout } from '../../../../utils/auth';
import { Analytics } from '../../../../utils/analytics';
import { AnalyticsType } from '../../../../types/Analytics';
import { sendRudderStackAnalyticsEvent } from '../../../../lib/BaseAnalyticsEvent';
const UserProfile = ({ userName, logoutRedirectLink, }) => {
    const onUserLogout = () => {
        Analytics.send(AnalyticsType.AMPLITUDE, { eventName: 'log out' });
        sendRudderStackAnalyticsEvent({
            eventName: 'click_cta',
            eventProperties: {
                type: 'click_logout',
                ux_source: 'desktop_user_profile',
                feature_utm: 'na',
            },
        });
        logout(logoutRedirectLink);
    };
    return (_jsxs(React.Fragment, { children: [_jsxs("div", { className: ivclass('iv-px-[27px] iv-py-[13px]', 'iv-whitespace-nowrap iv-overflow-ellipsis iv-overflow-hidden', 'iv-border-b iv-border-black-5', 'iv-text-black-85 dark:iv-text-grey-15', 'iv-text-body-2xl', 'iv-font-semibold'), children: ["Hi, ", userName] }), _jsx("div", { className: ivclass('iv-px-[27px] iv-py-[12px]'), children: _jsx("a", { className: ivclass('iv-inline-block', 'iv-w-full', 'iv-text-grey-50 iv-text-body-xl iv-font-medium'), href: HeaderConfig.HEADER_LINKS.userProfile, children: "Profile" }) }), _jsx("div", { className: "iv-border-t iv-border-black-5 iv-px-[27px] iv-py-[13px]", children: _jsx("div", { className: ivclass('iv-cursor-pointer', 'iv-text-body-xl', 'iv-text-grey-50', 'iv-font-medium'), onClick: onUserLogout, children: "Log Out" }) })] }));
};
export default UserProfile;
